import React from 'react';
import useCrmRoutes from '../../../hooks/useCrmRoutes';
import ProductList from './List';
import Details from './Details';
import Update from './Update';
import InternalRoutes from '../../../components/_organisms/InternalRoutes';

const Products: React.FC = () => {
  const { isCrmInternalRoute, actualRoute } = useCrmRoutes();

  const routes = [
    {
      component: Details,
      name: 'Products',
      path: `/crm/${actualRoute}/:productId`,
    },
    {
      exact: true,
      component: Update,
      name: 'Properties',
      path: `/crm/${actualRoute}/:id/edit`,
    },
    {
      exact: true,
      component: Update,
      name: 'Properties',
      path: `/crm/${actualRoute}/:id/edit/workOrders/:workOrderId/items/:workOrderItemId`,
    },
  ];

  if (isCrmInternalRoute) {
    return <InternalRoutes routes={routes} />;
  }

  return <ProductList />;
};

export default Products;
